export default {
  brand: {
    primary: {
      '50': '#eff9ff',
      '100': '#bee6ff',
      '200': '#82ceff',
      '300': '#30aeff',
      '400': '#0099fb',
      '500': '#0081d4',
      '600': '#006db3',
      '700': '#005890',
      '800': '#004a7a',
      '900': '#003659',
    },
    secondary: {
      '50': '#fff6ef',
      '100': '#ffd9be',
      '200': '#ffb681',
      '300': '#ff842c',
      '400': '#f56a06',
      '500': '#cf5905',
      '600': '#af4b04',
      '700': '#8d3d03',
      '800': '#773303',
      '900': '#562502',
    },
  },
  transparent: 'transparent',
  black: '#16161D',
  white: '#FFF',
  blue: '#006EF6',
  green: '#00BE85',
}
